import React, { useMemo, useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import Disposisi from '../../../utilities/Disposisi'
import TransaksiService from '../../../services/transaksi/TransaksiService'
import { FaMagnifyingGlass } from 'react-icons/fa6'
import ModalPnbpV2 from './ModalPnbpV2'
import SweetAlert from 'react-bootstrap-sweetalert'
import PbUmkuService from '../../../services/pbumku/PbumkuService'
import { getCurrentDateFormatted, romanNum } from '../../../utilities/Utils'
import { AsyncPaginate } from 'react-select-async-paginate'
import UserService from '../../../services/user/UserService'

const ModalPnbp = ({ showAddPnbp, handleClosePnbp, dataDisposisi, datappm, reloadList }) => {

    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    let userService = useMemo(() => new UserService(), [])

    const [tarifPnbp, setTarifPnbp] = useState(null)
    const [valueVolume, setValueVolume] = useState(0)
    const [rowPenugasan, setRowPenugasan] = useState(null)

    const [valuePejabatOpt, setValuePejabatOpt] = useState(null)

    const [loadingSave, setLoadingSave] = useState(false)

    const [showPnbpTarif, setShowPnbpTarif] = useState(false)
    const handleClosePnbpTarif = () => setShowPnbpTarif(false)

    const handleClickPnbpTarif = () => {
        setShowPnbpTarif(true)
    }

    const handleClickPilih = (dataclick) => {
        // console.log(dataclick)
        setTarifPnbp(dataclick)
        setShowPnbpTarif(false)
    }

    const onChangeVolume = e => {
        setValueVolume(e.target.value)
    }

    async function loadOptionPejabatTtd(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem('kdUnit'), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangePejabatOpt = e => {
        setValuePejabatOpt(e)
    }

    const [showConfirmSave, setShowConfirmSave] = useState(false)
    const handleCloseConfirmSave = () => setShowConfirmSave(true)
    const [savePnbpSuccess, setSavePnbpSuccess] = useState(false)
    const [savePnbpFailed, setSavePnbpFailed] = useState(false)

    const handleConfirmSave = (dataDisposisi) => {
        setRowPenugasan(dataDisposisi)
        setShowConfirmSave(true)
    }

    const handleClickSave = async () => {
        setLoadingSave(true)
        try {
            const respNomor = await pbumkuService.ambilNomorService('PPM_PNBP', datappm.kdUpt, currentYear, localStorage.getItem('username'))
            let noSuratTugas = respNomor.data.uraianPusat + '/' + respNomor.data.kodePusat + '/' + romanNum(currentMonth) + '/' + currentYear + '/' + respNomor.data.nomorUrut
            let jsonPnbp = { ...rowPenugasan, noTugas: noSuratTugas, tglTugas: getCurrentDateFormatted(), nipPejabat: valuePejabatOpt.nip, nmPejabat: valuePejabatOpt.nama, createdBy: localStorage.getItem("userId"), createdAt: new Date() }
            const _resPnbp = await transaksiService.addPenugasan(jsonPnbp)
            if (_resPnbp.data.kode === '200') {
                let jsonPnbp = {
                    nomorAju: datappm.nomorAju,
                    noPnbp: noSuratTugas,
                    tglPnbp: getCurrentDateFormatted(),
                    created: new Date(),
                    total: tarifPnbp !== null ? (tarifPnbp.tarif * valueVolume) : null,
                    pejabat: valuePejabatOpt.nip
                }
                const resPnbp = await transaksiService.addPnbp(jsonPnbp)
                if (resPnbp.data.kode === '200') {
                    let jsonPnbpDtl = {
                        nomorAju: datappm.nomorAju,
                        kodeTarif: tarifPnbp !== null ? tarifPnbp.kdTarif : '',
                        volume: valueVolume !== 0 ? valueVolume : 0,
                        satuan: tarifPnbp !== null ? tarifPnbp.satuan : '',
                        pembagi: tarifPnbp !== null ? tarifPnbp.pembagi : null,
                        totalTarif: tarifPnbp !== null ? (tarifPnbp.tarif * valueVolume) : null,
                        idPnbp: resPnbp.data.id
                    }
                    await transaksiService.addPnbpDetil(jsonPnbpDtl)
                    setShowConfirmSave(false)
                    setSavePnbpSuccess(true)
                }
            } else {
                setShowConfirmSave(false)
                setSavePnbpFailed(true)
            }
        } catch (error) {
            setSavePnbpFailed(true)
            setShowConfirmSave(false)
        }
        setLoadingSave(false)
    }

    const handleClickSaveSuccess = () => {
        setSavePnbpSuccess(false)
        reloadList(0, 10)
    }

    const handleClickSaveFailed = () => {
        setSavePnbpFailed(false)
    }

    return (
        <>
            <Modal
                show={showAddPnbp}
                onHide={handleClosePnbp}
                backdrop='static'
                keyboard={false}
                size='lg'
                centered
            >
                <Modal.Header>
                    <h6><Disposisi idDisposisi={dataDisposisi.idDisposisi} /></h6>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Aju</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.nomorAju} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nama Tarif</label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="jnsperiksa" value={tarifPnbp !== null ? tarifPnbp.nmTarif : ''} disabled />
                        </div>
                        <div className="col-sm-4">
                            <Button variant="primary" size="sm" onClick={() => handleClickPnbpTarif()} ><FaMagnifyingGlass /> Pilih Tarif</Button>{' '}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Tarif Pnbp</label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="jnsperiksa" value={tarifPnbp !== null ? tarifPnbp.tarif : null} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Satuan</label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="jnsperiksa" value={tarifPnbp !== null ? tarifPnbp.satuan : ''} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Volume</label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="jnsperiksa" value={valueVolume} onChange={onChangeVolume} />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Bendahara</label>
                        <div className="col-sm-8">
                            <AsyncPaginate
                                loadOptions={loadOptionPejabatTtd}
                                value={valuePejabatOpt}
                                getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                getOptionValue={(option) => option.nip}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangePejabatOpt}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => handleConfirmSave(dataDisposisi)} >Simpan</Button>{' '}
                    <Button variant="danger" size="sm" onClick={handleClosePnbp}>
                        Batal
                    </Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmSave &&
                <SweetAlert
                    title="Simpan Pnbp"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSave}
                    onCancel={handleCloseConfirmSave}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                savePnbpSuccess &&
                <SweetAlert
                    title="Simpan PNBP Berhasil"
                    success
                    onConfirm={handleClickSaveSuccess}
                    btnSize="sm"
                />
            }
            {
                savePnbpFailed &&
                <SweetAlert
                    title="Simpan PNBP Gagal"
                    danger
                    onConfirm={handleClickSaveFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
            <ModalPnbpV2 showAddPnbp={showPnbpTarif} handleClosePnbp={handleClosePnbpTarif} dataDisposisi={dataDisposisi} handleClickPilih={handleClickPilih} />
        </>
    )
}

export default ModalPnbp